@if (isInitialized) {
  <oe-chart [title]="component.alias">
    <oe-time-of-use-detail-chart [isOnlyChart]="true">
    </oe-time-of-use-detail-chart>
  </oe-chart>
}
